import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { CategoryTabSelectedTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackCategoryTabSelectedFunctionArgs {
  readonly tab: string;
}

interface TrackCategoryTabSelectedFunction {
  (args: TrackCategoryTabSelectedFunctionArgs): void;
}

interface UseTrackCategoryTabSelectedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackCategoryTabSelectedFunction {
  (agrs: UseTrackCategoryTabSelectedFunctionArgs): TrackCategoryTabSelectedFunction;
}

const useTrackCategoryTabSelected: UseTrackCategoryTabSelectedFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<CategoryTabSelectedTrackingEvent>();

  const trackCategoryTabSelected: TrackCategoryTabSelectedFunction = useCallback(
    ({ tab }) => {
      emitUserEvent({
        event: TrackingEventName.CATEGORY_TAB_SELECTED,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        tab,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackCategoryTabSelected;
};

export { useTrackCategoryTabSelected };
